import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-42">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-43" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="p-[1px] rounded-3xl bg-gradient-to-br from-blue-500 via-purple-500 to-blue-600 shadow-[0_0_50px_-12px_rgba(124,58,237,0.3)]" data-id="element-45">
          <div className="bg-[#0a0e1a] rounded-[23px] p-8 md:p-12 h-full" data-id="element-46">
            <div className="flex justify-center mb-6" data-id="element-47">
              <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 p-4 rounded-2xl border border-purple-500/30" data-id="element-48">
                <SparklesIcon className="w-10 h-10 text-purple-400" data-id="element-49" />
              </div>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-8" data-id="element-50">
              Presentamos el{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-51">
                Creative-to-Identity Mapping
              </span>
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-[1.8] text-center max-w-3xl mx-auto" data-id="element-52">
              <p data-id="element-53">
                Bajo el Protocolo Andromeda, dejamos de usar botones técnicos
                para segmentar y empezamos a usar el anuncio mismo como el
                filtro definitivo.
              </p>
              <p data-id="element-54">
                A través del Procesamiento de Lenguaje Natural (NLP), el
                algoritmo de Meta lee tu copy y reconoce a quién le hablas antes
                de que el primer usuario haga clic.
              </p>
              <p className="text-white font-medium" data-id="element-55">
                Tu anuncio se convierte en un "espejo" donde solo tu comprador
                ideal se ve reflejado, obligando al sistema a entregarte tráfico
                con alta intención de compra sin usar un solo interés.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}